export const remToPrercent = (rem: number) => {
  const remPx = remToPx(rem);
  const percent = remPx / window.innerWidth * 100;
  return percent;
}

export const remToPx = (rem: number) => {
  return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
}